(function () {
  'use strict';

  function showFirstOrderUsedPopup() {
    var overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:99999;display:flex;align-items:center;justify-content:center;padding:1rem;';

    var modal = document.createElement('div');
    modal.style.cssText = 'background:#fff;color:#111;border-radius:8px;padding:2rem 2rem 1.5rem;max-width:420px;width:100%;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,.25);';

    var title = document.createElement('p');
    title.style.cssText = 'font-size:1.1rem;font-weight:700;margin:0 0 .75rem;';
    title.textContent = 'Offre déjà utilisée';

    var body = document.createElement('p');
    body.style.cssText = 'font-size:.9rem;line-height:1.55;margin:0 0 1.5rem;opacity:.75;';
    body.textContent = 'Tu as déjà bénéficié de l\'abonnement gratuit. Pour continuer à accéder au Wellness Club, choisis l\'une de nos offres payantes.';

    var btn = document.createElement('button');
    btn.style.cssText = 'background:#111;color:#fff;border:none;border-radius:4px;padding:.7rem 1.75rem;font-size:.875rem;font-weight:600;cursor:pointer;';
    btn.textContent = 'Voir les offres';

    btn.addEventListener('click', function () {
      window.location.href = '/pages/nos-offres-1';
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) document.body.removeChild(overlay);
    });

    modal.appendChild(title);
    modal.appendChild(body);
    modal.appendChild(btn);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
  }

  document.addEventListener('submit', async function (event) {
    // Only intercept product add-to-cart forms
    if (!event.target.closest('product-form')) return;

    var form = event.target;

    // Re-triggered after our check — let ProductForm handle it
    if (form._subGuardPass) return;

    var fd = new FormData(form);
    var sellingPlan = fd.get('selling_plan');

    // Not a subscription product — don't interfere
    if (!sellingPlan) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var variantId = parseInt(fd.get('id'), 10);
    var planId    = parseInt(sellingPlan, 10);

    // Block free subscription if customer already used the first-order offer
    try {
      var tags = window.__customerTags || [];
      if (tags.indexOf('Active Subscriber') !== -1 || tags.indexOf('Inactive Subscriber') !== -1) {
        var variantInfo = await fetch(Shopify.routes.root + 'variants/' + variantId + '.js').then(function (r) { return r.json(); });
        if (variantInfo.price === 0) {
          showFirstOrderUsedPopup();
          return;
        }
      }
    } catch (_) {}

    try {
      var cart = await fetch(Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });

      var existingSubs = cart.items.filter(function (item) {
        return !!item.selling_plan_allocation;
      });

      // Same product + same plan already in cart — go straight to checkout
      var alreadyInCart = existingSubs.some(function (item) {
        return (
          item.variant_id === variantId &&
          item.selling_plan_allocation.selling_plan.id === planId
        );
      });

      if (alreadyInCart) {
        window.location.href = Shopify.routes.root + 'checkout';
        return;
      }

      // Different subscription(s) in cart — remove them first
      if (existingSubs.length > 0) {
        var updates = {};
        existingSubs.forEach(function (item) { updates[item.key] = 0; });
        await fetch(Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ updates: updates })
        });
      }
    } catch (_) {
      // Network error — let the normal submit proceed anyway
    }

    // Add to cart ourselves then redirect to checkout
    try {
      var addData = new FormData();
      addData.append('id', fd.get('id'));
      addData.append('quantity', fd.get('quantity') || 1);
      addData.append('selling_plan', sellingPlan);

      var res = await fetch(Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: addData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (res.ok) {
        window.location.href = Shopify.routes.root + 'checkout';
        return;
      }
    } catch (_) {}

    // Fallback : hand back to ProductForm if the add failed
    form._subGuardPass = true;
    try {
      form.requestSubmit();
    } catch (_) {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
    setTimeout(function () { delete form._subGuardPass; }, 0);

  }, { capture: true });
})();
